import { render, staticRenderFns } from "./CalculatedReference.vue?vue&type=template&id=04a31c8e&scoped=true&"
import script from "./CalculatedReference.vue?vue&type=script&lang=js&"
export * from "./CalculatedReference.vue?vue&type=script&lang=js&"
import style0 from "./CalculatedReference.vue?vue&type=style&index=0&id=04a31c8e&prod&scoped=true&lang=css&"
import style1 from "./CalculatedReference.vue?vue&type=style&index=1&id=04a31c8e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a31c8e",
  null
  
)

export default component.exports